export default {
  GET_UMKM_PAGE: (state, data) => {
    state.umkmPage = data;
  },
  GET_TOTAL_DATA: (state, data) => {
    state.total = data;
  },
};
